export function enumerable(value: boolean) {
  return (target: any, prop: string, descriptor?: PropertyDescriptor) => {
    if (descriptor) {
      // prototype property
      descriptor.enumerable = value
    } else {
      // instance property
      let propSymbol = Symbol(prop)

      Object.defineProperty(target, prop, {
        configurable: true,
        enumerable: value,
        get() {
          return this[propSymbol]
        },
        set(value) {
          this[propSymbol] = value
        },
      })
    }
  }
}
